export function getProviderByNameSpace(providerName) {
    const names = providerName.split('.')

    const providerOrNull = names.reduce((acc, cur) => {
        return acc?.[cur];
    }, window)
    return providerOrNull;
}